import React from 'react'
import CMS from '../../components/cms/CMS'
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
    const { t } = useTranslation();

    return (
        <CMS>
            <div className='h80 w-100 d-flex justify-content-center align-items-center'>
                <div className='border rounded-16 text-center p-2'>
                    <h1>{t("not_found")}</h1>
                    <p>{t("not_found_text")}</p>
                </div>
            </div>
        </CMS>
    )
}

export default NotFoundPage
